import * as basicScroll from 'basicscroll';

export class ParallaxMediaRuntimeElement extends HTMLElement {
    private img: HTMLImageElement;
    private parallax: string;
    private parallaxInstance: any;
    private resizeTimeout: any;
    private windowWidth: number;

    static get observedAttributes(): string[] {
        return ['data-media', 'data-parallax'];
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {       
        if (!['data-media', 'data-parallax'].includes(name) || oldValue === newValue) {
            return;
        }
        switch (name) {
            case 'data-media':
                if (oldValue !== null && this.parallax) {
                    this.cleanUpParallax();
                }
                if (newValue !== null && this.parallax) {
                    this.parallaxEffect();
                }
                break;
            case 'data-parallax':
                this.parallax = newValue;
                if (oldValue !== null) {
                    this.cleanUpParallax();
                }
                if (newValue !== null) {
                    this.parallaxEffect();
                }
                break;
            default:
                break;
        }
    }

    private parallaxUpdate = () => {
        this.parallaxInstance.calculate();
        this.parallaxInstance.update();
        this.windowWidth = window.innerWidth;
    }

    private cleanUpParallax = () => {        
        this.parallaxInstance?.destroy();
        window.removeEventListener('resize', this.resize);
        this.img?.removeEventListener('load', this.parallaxUpdate);
        this.img = undefined;
    }

    private parallaxEffect() {
        Promise.resolve().then(() => {
            if (!this.getAttribute('data-media')) {
                return;
            }

            let percentage: string;
            switch (this.parallax) {
                case 'parallax-fullw':
                    percentage = '12.5%';
                    break;
                case 'parallax-allgrid':
                    percentage = '15%';
                    break;
                case 'parallax-offsetgrid':
                    percentage = '40%';
                    break;
                case 'parallax-smallhero':
                    percentage = '20%';
                    break;
                default:
                    break;
            }
            this.parallaxInstance = basicScroll.create({
                elem: this.querySelector('.absolute'),
                from: 'top-middle',
                to: 'bottom-middle',
                direct: this,
                track: false,
                props: {
                    '--ty': {
                        from: 0,
                        to: percentage
                    }
                }
            });
            
            this.parallaxInstance.start();
            window.addEventListener('resize', this.resize);
            this.windowWidth = window.innerWidth;
            this.img = this.querySelector('img');
            this.img?.addEventListener('load', this.parallaxUpdate);
        });
    }

    private resize = () => {
        if (this.windowWidth === window.innerWidth) {
            return;
        }
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(this.parallaxUpdate, 200);
    }

    public connectedCallback(): void {
        if (this.parallax) {
            setTimeout(() => {
                this.parallaxEffect();
            });
        }
    }

    public disconnectedCallback(): void {
        this.cleanUpParallax();
    }
}